import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import componentStylesGeneric from "assets/theme/views/admin/generic.js";
import GenericButton from "components/Buttons/GenericButton";
import FormDropdown from "components/FormFields/FormDropdown";
import FormInputV2 from "components/FormFields/FormInputV2";
import FormSwitch from "components/FormFields/FormSwitch";
import FormDatePickerV2 from "components/FormFields/FormDatePickerV2";
import { Card, CardContent, CardHeader } from "@material-ui/core";
import { useDataset } from "hooks/useDataset";
import { useEffect, useRef } from "react";
import { useFormContext } from "react-hook-form";
import { DATASET } from "utils/const";

const useStylesGeneric = makeStyles(componentStylesGeneric);

const FilterSection = ({ onSearch, onClear, onAddMember, onAutoSearch, isLoading = false }) => {
  const classes = useStylesGeneric();
  const { control, handleSubmit, watch, getValues, trigger } = useFormContext();

  const { data: PROFESSIONAL_CATEGORY } = useDataset({ name: DATASET.PROFESSIONAL_CATEGORY });

  const showInactive = watch("showInactive");
  const expiringIn30Days = watch("expiringIn30Days");
  const didMountRef = useRef(false);

  useEffect(() => {
    if (!didMountRef.current) {
      didMountRef.current = true;
      return;
    }
    onAutoSearch?.();
  }, [showInactive, expiringIn30Days]); // eslint-disable-line react-hooks/exhaustive-deps

  const onSubmit = () => {
    onSearch?.();
  };

  return (
    <Card classes={{ root: classes.cardRoot }}>
      <form id="filter-cooperative-members" onSubmit={handleSubmit(onSubmit)}>
        <CardHeader
          classes={{
            action: classes.cardHeaderAction,
            title: classes.cardHeader,
          }}
          title={<Box>Pesquisa de Membros da Cooperativa</Box>}
          action={
            <GenericButton
              typeSubmit={false}
              size="medium"
              color="primary"
              onClick={onAddMember}
            >
              Adicionar Membro da Cooperativa
            </GenericButton>
          }
        />
        <CardContent>
          <Box>
            <Grid container classes={{ root: classes.containerPadding }}>
              <Grid item xs={12} sm={6} md={4}>
                <FormInputV2
                  name="name"
                  label="Nome do Membro"
                  placeholder="Informe o nome do membro"
                  control={control}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <FormInputV2
                  name="nif"
                  label="NIF"
                  placeholder="Informe o NIF"
                  control={control}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <FormInputV2
                  name="documentNumber"
                  label="N.º Documento de Identificação"
                  placeholder="Informe o N.º Documento de Identificação"
                  control={control}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <FormDropdown
                  label="Função"
                  placeholder="Seleccione a função"
                  control={control}
                  name="functionId"
                  options={PROFESSIONAL_CATEGORY}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <FormDatePickerV2
                  name="startDate"
                  label="Data de Registo (De)"
                  control={control}
                  getValues={getValues}
                  trigger={trigger}
                  endDateFieldName="endDate"
                  maxDateToday={true}
                  minDateToday={false}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <FormDatePickerV2
                  name="endDate"
                  label="Data de Registo (Até)"
                  control={control}
                  getValues={getValues}
                  trigger={trigger}
                  startDateFieldName="startDate"
                  maxDateToday={true}
                  minDateToday={false}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <FormSwitch
                  name="showInactive"
                  label="Mostrar Inactivos"
                  control={control}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <FormSwitch
                  name="expiringIn30Days"
                  label="Documentos a expirar em 30 dias"
                  control={control}
                />
              </Grid>
              <Grid
                item
                xs={12}
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "1rem",
                  marginTop: "1rem",
                }}
              >
                <GenericButton
                  typeSubmit={false}
                  size="medium"
                  color="tertiary"
                  onClick={onClear}
                  disabled={isLoading}
                >
                  Limpar Filtros
                </GenericButton>
                <GenericButton
                  typeSubmit={true}
                  size="medium"
                  color="primary"
                  loading={isLoading}
                >
                  Pesquisar
                </GenericButton>
              </Grid>
            </Grid>
          </Box>
        </CardContent>
      </form>
    </Card>
  );
};

export default FilterSection;
